"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderCartButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _addToCart = _interopRequireDefault(require("../../elements/buttons/add-to-cart"));
/**
  * Render action buttons
  * @module HeaderCartButton
  *
  * @param {Object} props React props for for element
  * @param {Boolean} triggerHeaderCart Flag to trigger headercart
  * @param {String} props.nsMerchButtonProps NSMerchButton props
  * @returns {React.ReactElement} UXCore ButtonSet component
  * @public
  */

function HeaderCartButton({
  actionKey = '',
  configKey = '',
  id,
  action,
  itemTrackingCode,
  isc,
  source = 'ac',
  destination,
  productPackage,
  productPackageTermLengthInMonths,
  addOnItems,
  width = 'auto',
  ...nsMerchButtonProps
}) {
  if (productPackage && action) {
    return /*#__PURE__*/_react.default.createElement(_addToCart.default, (0, _extends2.default)({
      id,
      action,
      itemTrackingCode,
      isc,
      source,
      destination,
      productPackage,
      productPackageTermLengthInMonths,
      addOnItems,
      width,
      isHeaderCart: true
    }, nsMerchButtonProps));
  }
  return /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({
    width: width
  }, nsMerchButtonProps, {
    onClick: () => (0, _patternLibraryUtils.openHeaderCart)({
      actionKey,
      configKey
    })
  }));
}
HeaderCartButton.propTypes = {
  actionKey: _propTypes.default.string,
  id: _propTypes.default.string,
  itemTrackingCode: _propTypes.default.string,
  productPackage: _propTypes.default.string,
  action: _propTypes.default.string,
  productPackageTermLengthInMonths: _propTypes.default.string,
  addOnItems: _propTypes.default.array,
  source: _propTypes.default.oneOf(['ac', 'gs', 'gc']),
  destination: _propTypes.default.oneOf(['cart', 'config', 'freedomain', 'basket']),
  isc: _propTypes.default.string,
  width: _propTypes.default.oneOf(['auto', 'full']),
  configKey: _propTypes.default.string
};